// extracted by mini-css-extract-plugin
export default {"wrapper":"YB-z","viewport":"ZB-z","container":"_B-z","slide":"aC-z"};